import { socialLinks } from './socialLinks.data';
export { socialLinks };
